import { FC } from "react";
import { useTripItinerariesQuery } from "@/fetch/inventory";
import ItineraryMap from "./ItineraryMap";

import styles from "./TripItinerary.module.scss";

const TripItinerary: FC = () => {
  const { data: tripItineraries } = useTripItinerariesQuery();
  return (
    <ItineraryMap
      itinerary={tripItineraries?.response || []}
      id={"1"}
      map={{ lat: 0, lng: 0, zoom: 1 }}
      title="Trip Itinerary"
    />
  );
};

export default TripItinerary;
